import React from 'react';
import styles from './AwardApproval.module.scss';
import HATVABOTable from '../HATVABOTable/HATVABOTable';
import MyAccountsLoader from '../../../common/Loaders/MyAccountsLoader/MyAccountsLoader';
import { useTranslation } from 'react-i18next';

interface AwardApprovalProps {
  data: TableRowData[] | undefined;
  isAwardApprovalLoading: boolean;
  isError: boolean;
  setIsStatusUpdate?: (apiStatus: string) => void;
}

const AwardApproval: React.FC<AwardApprovalProps> = ({
  data,
  isAwardApprovalLoading,
  isError,
  setIsStatusUpdate,
}) => {
  const { t } = useTranslation();

  if (isAwardApprovalLoading || data === undefined) {
    return <MyAccountsLoader num={6} hideCustomViewPanel />;
  }
  if (!isError && data.length > 0) {
    return (
      <div data-testid="hatv_awardApproval_testID">
        <HATVABOTable
          data={data}
          isAwardApproval
          isAwardApprovalLoading={false}
          setIsStatusUpdate={setIsStatusUpdate}
          type={'hatvawards'}
        />
      </div>
    );
  }

  if (!isAwardApprovalLoading && !isError && data.length === 0) {
    return (
      <div className={styles.empty_state_document}>
        <div className={`table_no_data ${styles.empty_state_msg}`}>{t('noAboAvailable')}</div>
      </div>
    );
  }

  return null;
};

export default AwardApproval;
